"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Content_1 = __importDefault(require("./Content"));
class Index {
    constructor(parent, messageId = null) {
        this.parent = parent;
        this.rc = parent.rc;
        this.messageId = messageId;
    }
    path(withParameter = true) {
        if (withParameter && this.messageId !== null) {
            return `${this.parent.path()}/message-store/${this.messageId}`;
        }
        return `${this.parent.path()}/message-store`;
    }
    /**
     * Returns a list of messages from an extension mailbox.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store
     * Rate Limit Group: Light
     * App Permission: ReadMessages
     * User Permission: ReadMessages
     */
    async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes conversation(s) by conversation ID(s). Batch request is
   * supported, max number of IDs passed as query/path parameters is 50. Alternative
   * syntax is supported - user conversations can be deleted by passing multiple
   * IDs in request body as an array of string, max number of conversation IDs
   * passed in request body is 100. In this case asterisk is used in the path instead
   * of IDs
   *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store
     * Rate Limit Group: Medium
     * App Permission: EditMessages
     * User Permission: EditMessages
     */
    async deleteAll(queryParams, restRequestConfig) {
        const r = await this.rc.delete(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns an individual message record or multiple records by the given message ID(s).
   * The length of inbound messages is unlimited. Bulk syntax is supported.
   *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store/{messageId}
     * Rate Limit Group: Light
     * App Permission: ReadMessages
     * User Permission: ReadMessages
     */
    async get(restRequestConfig) {
        if (this.messageId === null) {
            throw new Error('messageId must be specified.');
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates message(s) by their ID(s). Currently only message read status
   * can be updated through this method.
   *
   * Bulk syntax is supported, max number of IDs passed as query/path
   * parameters is 50. Alternative bulk syntax is also supported - user messages can be updated
   * by passing multiple IDs in request body as an array of string, max number
   * of IDs passed in the body is 1000. In this case asterisk is used in the
   * path instead of IDs.
   *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store/{messageId}
     * Rate Limit Group: Medium
     * App Permission: EditMessages
     * User Permission: EditMessages
     */
    async put(updateMessageRequest, restRequestConfig) {
        if (this.messageId === null) {
            throw new Error('messageId must be specified.');
        }
        const r = await this.rc.put(this.path(), updateMessageRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes message(s) by the given message ID(s). The first call of
   * this method transfers the message to the 'Delete' status. The second call
   * transfers the deleted message to the 'Purged' status. If it is required to
   * make the message 'Purged' immediately (from the first call), then set the
   * query parameter purge to `true`.
   *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store/{messageId}
     * Rate Limit Group: Medium
     * App Permission: EditMessages
     * User Permission: EditMessages
     */
    async delete(deleteMessageBulkRequest, queryParams, restRequestConfig) {
        if (this.messageId === null) {
            throw new Error('messageId must be specified.');
        }
        const r = await this.rc.delete(this.path(), deleteMessageBulkRequest, queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Patches message(s) by ID(s). Currently only message read status update and
   * restoring deleted messages are supported through this method.
   *
   * For changing status of a message send `readStatus` set to either 'Read' or 'Unread' in request.
   * It is possible to restore a message and its attachments (if message status is 'Deleted') by sending
   * `availability` attribute set to 'Alive' in request body. If a message is already in 'Purged' state
   * then its attachments cannot be restored and the message itself is about to be physically deleted.
   *
   * Bulk syntax (both traditional and alternative one) is supported.
   *
     * HTTP Method: patch
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store/{messageId}
     * Rate Limit Group: Medium
     * App Permission: EditMessages
     * User Permission: EditMessages
     */
    async patch(patchMessageRequest, restRequestConfig) {
        if (this.messageId === null) {
            throw new Error('messageId must be specified.');
        }
        const r = await this.rc.patch(this.path(), patchMessageRequest, undefined, restRequestConfig);
        return r.data;
    }
    content(attachmentId = null) {
        return new Content_1.default(this, attachmentId);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map